import clsx from 'clsx'
import { useState } from 'react'
import { SearchIcon } from '../../GlobalComponents/_icons/Icons'
import { FastQuoteInput } from '../../GlobalComponents/Inputs/Inputs'
import styles from '../AssemblySearch.module.scss'

interface AssemblySearchInputProps {
    onSearch(val: string): void
}
export default function AssemblySearch(props: AssemblySearchInputProps) {
    const { onSearch } = props

    const [inputValue, setInputValue] = useState<string>('')
    const [currentSearch, setCurrentSearch] = useState<string>('')

    const handleKeyPress = (e: any) => {
        e.key === 'Enter' && handleInputChange()
    }

    const handleBlur = () => handleInputChange()

    const handleInputChange = () => {
        if (inputValue !== currentSearch) {
            onSearch(inputValue)
            setCurrentSearch(inputValue)
        }
    }

    return (
        <div className={styles.AssemblySearchInput}>
            <FastQuoteInput
                title={<div style={{ display: 'inline' }}>Search</div>}
                Icon={SearchIcon}
                onChange={setInputValue}
                onKeyPress={handleKeyPress}
                onBlur={handleBlur}
                value={inputValue}
                placeholder={'Search by IAM, Customer, Description, Attributes'}
                renderEndIcon={() =>
                    inputValue && (
                        <div
                            style={{ width: 18, height: 15 }}
                            className={'a-i-close'}
                            // intentionally mousedown because mousedown triggers parent blur
                            onMouseDown={() => setInputValue('')}
                        />
                    )
                }
            />
        </div>
    )
}
